import Token from '@/utils/Token';

export default {
    tipos(origem = 'contratos') {
        return axios.get(`/api/arquivo-lote/tipos?origem=${encodeURIComponent(origem)}`, Token.getHeader());
    },
    store(payload) {
        return axios.post('/api/arquivo-lote', payload, Token.getHeader());
    },
    list(params = '') {
        if (params) {
            params = `?${params}`;
        }
        return axios.get(`/api/arquivo-lote/list${params}`, Token.getHeader());
    },
    show(id) {
        return axios.get(`/api/arquivo-lote/${id}`, Token.getHeader());
    },
    destroy(id) {
        return axios.delete(`/api/arquivo-lote/${id}`, Token.getHeader());
    },
    limpar(apenasErro = false) {
        const params = apenasErro ? '?apenas_erro=1' : '';
        return axios.post(`/api/arquivo-lote/limpar${params}`, {}, Token.getHeader());
    },
    download(id) {
        const headers = Token.getHeader();
        headers.responseType = 'blob';

        return axios.get(`/api/arquivo-lote/${id}/download`, headers);
    },
};
